import React from "react";
import { Link } from "react-router-dom";

const SocialLinks = () => {
  return (
    <div className="social-links">
      <Link to="">
        <i className="iconify social-links__icon" data-icon="jam:facebook" />
      </Link>
      <Link to="">
        <i className="iconify social-links__icon" data-icon="pajamas:twitter" />
      </Link>
      <Link to="">
        <i className="iconify social-links__icon" data-icon="mdi:instagram" />
      </Link>
      <Link to="">
        <i
          className="iconify social-links__icon"
          data-icon="ic:baseline-tiktok"
        />
      </Link>
      <Link to="">
        <i className="iconify social-links__icon" data-icon="mdi:linkedin" />
      </Link>
      <Link to="">
        <i
          className="iconify social-links__icon"
          data-icon="mdi:youtube"
          style={{ fontSize: "26px" }}
        />
      </Link>
    </div>
  );
};

export default SocialLinks;
